import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, X } from 'lucide-react';
import { Button } from 'components/Elements';
import AshitaLogo from 'assets/logo.svg';

export const Header = ({ user, onStart }) => {
  const [open, setOpen] = useState(false);

  const navigate = useNavigate();

  const nav = [
    { name: 'Platform', href: '#platform' },
    { name: 'Integrations', href: '#integrations' },
    { name: 'Developers', href: '#developers' },
    { name: 'Pricing', href: '#pricing' },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50">
      <div className="text-center p-4 bg-gray-800 text-sm">
        Save 50% for 12 months - limited time offer.{' '}
        <Link to="/" className="text-red-600">
          Get started today
        </Link>
        .
      </div>
      <div className="backdrop-blur-xl bg-white border-b border-white/10">
        <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-3">
            <img src={AshitaLogo} alt="Ashita Logo" width="64" />

            <div className="hidden sm:block">
              <div className="font-semibold text-gray-800">Ashita Creatives</div>

              <div className="text-xs text-slate-600">AI CMS Solutions</div>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {nav.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm text-slate-600 hover:text-gray-800 font-semibold transition"
              >
                {item.name}
              </a>
            ))}
          </nav>

          {/* Desktop CTA */}
          <div className="hidden md:flex items-center gap-3">
            {!user && (
              <Button
                variant="ghost"
                className="text-slate-600 hover:text-gray-900"
                onClick={onStart}
              >
                Login
              </Button>
            )}

            <Button onClick={onStart}>{user ? 'Open Console' : 'Start Building'}</Button>
          </div>

          {/* Mobile Toggle */}
          <button className="md:hidden p-2 rounded-lg bg-gray-800" onClick={() => setOpen(!open)}>
            {open ? <X size={20} /> : <Menu size={20} />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}

      {open && (
        <div className="md:hidden backdrop-blur-xl bg-slate-950/95 border-b border-white/10">
          <div className="px-6 py-6 flex flex-col gap-6">
            {nav.map((item) => (
              <a
                key={item.name}
                href={item.href}
                onClick={() => setOpen(false)}
                className="text-slate-300 hover:text-white"
              >
                {item.name}
              </a>
            ))}

            <div className="pt-4 border-t border-white/10 flex flex-col gap-3">
              {!user && (
                <Button variant="ghost" onClick={() => navigate('/auth/login')}>
                  Login
                </Button>
              )}

              <Button onClick={onStart}>{user ? 'Open Console' : 'Start Building'}</Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};
